export default __webpack_public_path__ + "static/media/M28.6cc44a4e.svg";